import React from 'react'
import { productStatusOptions } from './productStatusOptions'
import { ProductStatusSelect } from './ProductStatusSelect'
import { SelectInlineInput } from '@ztechapps/webui.input'

export const ProductStatusSelectInlineInput = ({ ...rest }: any) => {
  return <SelectInlineInput {...rest} selectComponent={ProductStatusSelect} selectOptions={productStatusOptions} />
}
